import React from "react";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import "./StatusChart.scss";

function StatusAndGroupSelector({
  selectedGroups,
  setGroupDetails,
  setWebVitalsStatus,
  wvStatusList,
  groupDetails,
  WVStatus,
  selectedCheckbox,
  setSelecteCheckbox,
}) {
  //OTHERS
  const isGroupDetails = selectedCheckbox === "groupDetails";
  const isCompareGroup = selectedCheckbox === "compareGroup";

  return (
    <div className="status-chart-container">
      <div
        className={`group-selector-container ${
          isGroupDetails && "yellow-background"
        }`}
      >
        <div
          className={"checkbox-container"}
          onClick={() => setSelecteCheckbox("groupDetails")}
        >
          <input
            type={"checkbox"}
            onChange={() => setSelecteCheckbox("groupDetails")}
            checked={isGroupDetails}
          />
          <p>Detalhe do Grupo</p>
        </div>
        <FormControl>
          <InputLabel>Grupo</InputLabel>
          <Select
            native
            label="Grupo"
            size="small"
            onChange={(event) => setGroupDetails(event.target.value)}
            value={groupDetails}
          >
            {selectedGroups?.map((group) => (
              <option value={group?.id} key={group?.id}>
                {`${group.id} - ${group?.name}`}
              </option>
            ))}
          </Select>
        </FormControl>
      </div>

      <div
        className={`status-selector-container ${
          isCompareGroup && "yellow-background"
        }`}
      >
        <div
          className="checkbox-container"
          onClick={() => setSelecteCheckbox("compareGroup")}
        >
          <input
            type={"checkbox"}
            onChange={() => setSelecteCheckbox("compareGroup")}
            checked={isCompareGroup}
          />
          <p>Comparar grupos</p>
        </div>
        <FormControl>
          <InputLabel>Status</InputLabel>
          <Select
            native
            label="Status"
            onChange={(event) => setWebVitalsStatus(event.target.value)}
            size="small"
            value={WVStatus}
          >
            {wvStatusList?.map((status) => (
              <option key={status?.value} value={status?.value}>
                {status?.label}
              </option>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

export default StatusAndGroupSelector;
